import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import {faArrowTrendUp} from "@fortawesome/pro-regular-svg-icons/faArrowTrendUp";
import Button from "@/components/Global/Button/Button";
import RenderIf from "@/components/Global/RenderIf/RenderIf";

import styles from "./HealthScoreHeader.module.scss";

export default function HealthScoreHeader({handleBack, children, backButtonText, showTrend}) {
  return (
    <>
      <div className="bg-purple-200 p-2 text-center">
        <div className={`${styles.hcPill} rounded d-inline-flex justify-content-center`}>
          <div className={`${styles.hcPillGradient} py-1 px-3 rounded-start-pill`}>HealthCoach</div>
          <div className="py-1 px-3 rounded-end-pill">BETA</div>
        </div>
      </div>
      <div className={`${styles.container} row g-0 px-2 py-3 align-items-center position-relative`}>
        <div className="col-auto">
          <Button variant="transparent" className="p-0" onClick={handleBack} aria-label="go back">
            <FontAwesomeIcon icon={faArrowLeft} size="lg" className="ps-2" /> {backButtonText}
          </Button>
        </div>
        <div className="col text-center fw-semibold">{children}</div>
        <RenderIf isTrue={showTrend}>
          <div className="col-auto">
            <Button
              variant="transparent"
              className="p-0 d-flex flex-column align-items-center"
              data-bs-target="#trendsModal"
              data-bs-toggle="modal">
              <FontAwesomeIcon icon={faArrowTrendUp} size="lg" className="mx-auto fa-fw mb-1" />
              <small>Trends</small>
            </Button>
          </div>
        </RenderIf>
      </div>
    </>
  );
}
